import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const StepConsolidacao = ({ consolidacao, onChange, onSave, readOnly }) => {
  const update = (field, value) => onChange({ ...consolidacao, [field]: value });
  return (
    <Card>
      <CardHeader><CardTitle>Consolidação</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div><Label>Diagnóstico</Label><Textarea value={consolidacao?.diagnostico || ""} disabled={readOnly} onChange={(e) => update("diagnostico", e.target.value)} /></div>
        <div><Label>Prognóstico</Label><Textarea value={consolidacao?.prognostico || ""} disabled={readOnly} onChange={(e) => update("prognostico", e.target.value)} /></div>
        <div><Label>Recomendações</Label><Textarea value={consolidacao?.recomendacoes || ""} disabled={readOnly} onChange={(e) => update("recomendacoes", e.target.value)} /></div>
        <div><Label>Limitações</Label><Textarea value={consolidacao?.limitacoes || ""} disabled={readOnly} onChange={(e) => update("limitacoes", e.target.value)} /></div>
        {!readOnly && <Button onClick={onSave}>Salvar</Button>}
      </CardContent>
    </Card>
  );
};

export default StepConsolidacao;
